// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"24f2f9b0","453":"4504b347","732":"be8a5aab","977":"b5160fc1"}[chunkId] + ".chunk.js";
};